import React, {useEffect} from 'react';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import Navbar from 'components/Navbar';
import Footer from 'components/Footer';
import {ProtectedRoute, LoginModal} from 'components/Auth';
import HomePage from 'views/Home';
import SafetyNow from 'views/Tools/SafetyNow';
import SafetyPro from 'views/Tools/SafetyPro';
import SafetyGuru from 'views/Tools/SafetyGuru';
import SafetyBuddy from 'views/Tools/SafetyBuddy';
import SearchResult from 'views/Tools/SafetyNow/SearchResult';
import ChemicalProfile from 'views/Tools/SafetyNow/ChemicalProfile';
import UserSDSDatasheet from 'views/Tools/SafetyNow/UserSDSDatasheet';
import VentilationCalculator from 'views/Tools/SafetyPro/VentilationCalculator';
import InertizationCalculator from 'views/Tools/SafetyPro/InertizationCalculator';
import ToolsPage from 'views/Tools';
import SurveyPage from 'views/Survey';
import AboutPage from 'views/About';
import PrivacyPolicy from 'views/PrivacyPolicy';
import TermsOfUse from 'views/TermsOfUse';
import Register from 'views/Auth/Register';
import Profile from 'views/Auth/Profile';
import { LocationProvider } from 'context/LocationContext';
import { CacheProvider } from 'context/CacheContext';
import { AuthProvider, useAuth } from 'context/AuthContext';
import {animateScroll as scroll} from 'react-scroll'
// import { motion, AnimatePresence } from 'framer-motion';
import FeedbackForm from 'components/FeedbackForm';

const LoginRedirect = () => {
  const { openLoginModal } = useAuth();
  const navigate = useNavigate();

  React.useEffect(() => {
    // Open the login modal and redirect to the home page
    openLoginModal();
    navigate('/', { replace: true });
  }, [openLoginModal, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-600"></div>
    </div>
  );
};

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    scroll.scrollToTop({
      duration: 300,      // optional: smooth animation
      smooth: true,       // optional: set to false for instant scroll
    });
  }, [pathname]);

  return null; // This component does not render anything
};


const blackoutVariants = {
  initial: { opacity: 1 },
  animate: { opacity: 0, transition: { duration: 0.15 } },
  exit: { opacity: 1, transition: { duration: 0.15 } },
};

const PageTransition = ({ children }) => {
  const location = useLocation();

  return (
    <>
    {/* <AnimatePresence mode="wait">
      <motion.div
        key={location.pathname}
        variants={blackoutVariants}
        initial="initial"
        animate="animate"
        exit="exit"
        style={{
          position: 'absolute',
          width: '100%',
          height: '100%',
          top: 0,
          left: 0,
          backgroundColor: 'rgba(0,0,0,0)',
          zIndex: 9999,
          pointerEvents: 'none',
        }}
      /> */}
      {children}
    {/* </AnimatePresence> */}
    </>
  );
};


function App() {
  return (
    <LocationProvider>
      <CacheProvider>
        <AuthProvider>
          <div id="main">
            <PageTransition>
                  <ScrollToTop />
                  <Navbar />
                  <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/tools" element={<ToolsPage />} />
                    <Route path="/tools/safety-now" element={<SafetyNow />} />
                    <Route path="/tools/safety-now/sds/:id" element={<UserSDSDatasheet />} />
                    <Route path="/tools/safety-pro" element={<SafetyPro />} />
                    <Route path="/tools/safety-guru" element={<SafetyGuru />} />
                    <Route path="/tools/safety-buddy" element={<SafetyBuddy />} />
                    <Route path="/tools/safety-now/search" element={<SearchResult />} />
                    <Route path="/tools/safety-now/search/:productName/:cid" element={<ChemicalProfile />} />              
                    <Route path="/tools/safety-pro/ventilation" element={<VentilationCalculator />} />
                    <Route path="/tools/safety-pro/inertization" element={<InertizationCalculator />} />
                    <Route path="/survey" element={<SurveyPage />} />
                    <Route path="/about" element={<AboutPage />} />              
                    <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                    <Route path="/terms-of-use" element={<TermsOfUse />} />
                    {/* <Route path="/login" element={<LoginRedirect />} /> */}
                    <Route path="/register" element={<Register />} />
                    <Route path="/profile" element={
                      <ProtectedRoute>
                        <Profile />
                      </ProtectedRoute>
                    } />
                    {/* <Route path="/resources" element={<Resources />} /> */}
                </Routes>
                <FeedbackForm />
                <Footer />
            </PageTransition>
            
            {/* Login Modal - available globally */}
            <LoginModalContainer />
          </div>
        </AuthProvider>
      </CacheProvider>
    </LocationProvider>
  );
}

// This component uses the auth context to control the login modal
const LoginModalContainer = () => {
  const { isLoginModalOpen, closeLoginModal, loginRedirectPath } = useAuth();
  
  return (
    <LoginModal 
      isOpen={isLoginModalOpen} 
      onClose={closeLoginModal} 
      redirectPath={loginRedirectPath}
    />
  );
};

export default App;
